import React from 'react';
import { Button } from '../../ui/button';

const ImportEmailListModal = ({
  open,
  onClose,
  listName,
  setListName,
  listData,
  setListData,
  onSubmit,
  loading,
}) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="import-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Import Email List</h3>
        <p className="import-instructions">
          Paste your email list below. Format: one email per line, or email,name per line.
        </p>

        <div className="email-field">
          <label>List Name:</label>
          <input
            type="text"
            value={listName}
            onChange={(e) => setListName(e.target.value)}
            placeholder="e.g., Leaguelineup Contacts"
            className="email-input"
          />
        </div>

        <div className="email-field">
          <label>Email Data:</label>
          <textarea
            value={listData}
            onChange={(e) => setListData(e.target.value)}
            placeholder="email@example.com,John Doe&#10;email2@example.com,Jane Smith"
            className="email-textarea"
            rows={10}
          />
        </div>

        <div className="modal-actions">
          <Button
            onClick={onSubmit}
            className="import-submit-btn"
            disabled={loading || !listData.trim() || !listName.trim()}
          >
            {loading ? 'Importing...' : 'Import List'}
          </Button>
          <Button onClick={onClose} className="cancel-btn">
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImportEmailListModal;
